import PBService from "@irati/utils/services"
import client, {MutationOptions, QueryOptions} from "@irati/utils/services/apollo"
import {CheckoutRedemption, HelixOrder, QueryRedemptionsArgs} from "@irati/types"
import listFormat from "@irati/utils/services/graph/utils/listFormat"
import auth from "@irati/auth"

import toggleCheckoutRedemptionUsedMutation, {toggleCheckoutRedemptionUsedKey} from "./mutations/toggleCheckoutRedemptionUsed"
import archiveCheckoutRedemptionMutation from "./mutations/archiveCheckoutRedemption"
import redemptionQuery, {redemptionQueryKey} from "./queries/redemption"
import redemptionListQuery, {redemptionListQueryKey} from "./queries/redemptions"
import redemptionStatusQuery, {redemptionStatusQueryKey} from "./queries/redemptionStatus"

class RedemptionsService extends PBService {
  get(redemptionId: string, options: QueryOptions = {}): Promise<CheckoutRedemption> {
    const variables = {uuid: redemptionId}

    return client.query({...options, query: redemptionQuery, variables}).then(({data}) => data[redemptionQueryKey])
  }

  list(variables: Partial<QueryRedemptionsArgs>, options: QueryOptions = {}): Promise<CheckoutRedemption[]> {
    return client.query({...options, query: redemptionListQuery, variables}).then(({data}) => {
      return listFormat(data[redemptionListQueryKey])
    })
  }

  archive(redemptionId: string, ifMatch: string, options: MutationOptions = {}): Promise<boolean | void> {
    const variables = {redemptionId, ifMatch}
    return client.mutate({...options, mutation: archiveCheckoutRedemptionMutation, variables}).then(() => true)
  }

  toggleIsUsed(redemption: CheckoutRedemption, {refetchAll = false} = {}, options: MutationOptions = {}): Promise<CheckoutRedemption> {
    const {uuid, isUsed} = redemption

    const refetchQueries = [
      {
        query: redemptionListQuery,
        variables: {isUsed: !isUsed, userId: auth.user().uuid}
      }
    ]
    if (refetchAll) {
      refetchQueries.push({
        query: redemptionListQuery,
        variables: {isUsed, userId: auth.user().uuid}
      })
    }

    return client
      .mutate({
        ...options,
        mutation: toggleCheckoutRedemptionUsedMutation,
        variables: {redemptionId: uuid, isUsed},
        refetchQueries
      })
      .then(({data}) => data[toggleCheckoutRedemptionUsedKey])
  }

  async getMerchandiseStatus(redemptionId: string, options: QueryOptions = {}): Promise<Pick<HelixOrder, "action" | "data">> {
    const variables = {redemptionId}

    const {data} = await client.query({...options, query: redemptionStatusQuery, variables})
    return data[redemptionStatusQueryKey]
  }
}

const redemptionService = new RedemptionsService({errorHandlers: []})

export default redemptionService
